<template>
  <div class="container page" style="background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto;;padding-bottom: 20px;">
    <van-nav-bar :title="$t('recharge.recharge')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
      <template #right>
        <span class="nav-right" style="color:#fff" @click="$router.push({path:'/RechargeRecord'})">{{$t("foorter.ti_record")}}</span>
      </template>
    </van-nav-bar>
	<div style="padding: 0 12px;box-sizing: border-box;padding-top:20px;background: #fff;padding-bottom: 40px;">
		<div v-if="currentCryptoMethod">
			<div class="qrcode-box">
				<img v-if="qrCodeUrl" :src="qrCodeUrl" class="qrcode-img">
			</div>
			<div style="text-align: center;margin:10px 0;">
				<div style="margin-bottom:10px;">{{currentCryptoMethod.title}}</div>
			</div>
			<div style="width: 100%;line-height: 30px;font-size: 14px;text-align: left;padding-left: 5px;color: #999">
				{{currentCryptoMethod.addressLabel}}
			</div>
			<div style="background: #fff;box-shadow: 0 0 10px 0 #e9e9e9;border-radius: 4px;height: 40px;">
				<div style="overflow: visible;osition: relative;overflow: hidden;color: #323233;text-align: left;vertical-align: middle;word-wrap: break-word;">
					<div style="display: flex;-webkit-box-align: center;-webkit-align-items: center;-ms-flex-align: center;align-items: center;">
						<div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width:85%;font-size: 14px;line-height:40px;color: #000;padding-left: 10px;">
							{{currentCryptoAddress}}
						</div>
						<div style="padding-left:8px;margin-right:10px" @click="copys(currentCryptoAddress)">
							<span style="color: rgb(102, 102, 102);font-size: 16px;text-align: left">Copy</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="class1">
			<div style="width: 100%;line-height: 30px;font-size: 14px;text-align: left;padding-left: 5px;color: #999">
				{{$t("setting.username")}}
			</div>
			<div style="background: #fff;box-shadow: 0 0 10px 0 #e9e9e9;border-radius: 4px;height: 40px;">
				<div style="overflow: visible;osition: relative;overflow: hidden;color: #323233;text-align: left;vertical-align: middle;word-wrap: break-word;">
					<div style="display: flex;-webkit-box-align: center;-webkit-align-items: center;-ms-flex-align: center;align-items: center;">
						<div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width:85%;font-size: 14px;line-height:40px;color: #000;padding-left: 10px;">
							{{withdrawRole.names}}
						</div>
						<div style="padding-left:8px;margin-right:10px;" @click="copys(withdrawRole.names)">
							<span style="color: rgb(102, 102, 102);font-size: 16px;text-align: left">Copy</span>
						</div>
					</div>
				</div>
			</div>
			<div style="width: 100%;line-height: 30px;font-size: 14px;text-align: left;padding-left: 5px;color: #999">
				{{$t("setting.band_name")}}
			</div>
			<div style="background: #fff;box-shadow: 0 0 10px 0 #e9e9e9;border-radius: 4px;height: 40px;">
				<div style="overflow: visible;osition: relative;overflow: hidden;color: #323233;text-align: left;vertical-align: middle;word-wrap: break-word;">
					<div style="display: flex;-webkit-box-align: center;-webkit-align-items: center;-ms-flex-align: center;align-items: center;">
						<div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width:85%;font-size: 14px;line-height:40px;color: #000;padding-left: 10px;">
							{{withdrawRole.bankname}}
						</div>
						<div style="padding-left:8px;margin-right:10px" @click="copys(withdrawRole.bankname)">
							<span style="color: rgb(102, 102, 102);font-size: 16px;text-align: left">Copy</span>
						</div>
					</div>
				</div>
			</div>
			<div style="width: 100%;line-height: 30px;font-size: 14px;text-align: left;padding-left: 5px;color: #999">
				{{$t("setting.branch_name")}}
			</div>
			<div style="background: #fff;box-shadow: 0 0 10px 0 #e9e9e9;border-radius: 4px;height: 40px;">
				<div style="overflow: visible;osition: relative;overflow: hidden;color: #323233;text-align: left;vertical-align: middle;word-wrap: break-word;">
					<div style="display: flex;-webkit-box-align: center;-webkit-align-items: center;-ms-flex-align: center;align-items: center;">
						<div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width:85%;font-size: 14px;line-height:40px;color: #000;padding-left: 10px;">
							{{withdrawRole.fname}}
						</div>
						<div style="padding-left:8px;margin-right:10px" @click="copys(withdrawRole.fname)">
							<span style="color: rgb(102, 102, 102);font-size: 16px;text-align: left">Copy</span>
						</div>
					</div>
				</div>
			</div>
			<div style="width: 100%;line-height: 30px;font-size: 14px;text-align: left;padding-left: 5px;color: #999">
				{{$t("setting.branch_code")}}
			</div>
			<div style="background: #fff;box-shadow: 0 0 10px 0 #e9e9e9;border-radius: 4px;height: 40px;">
				<div style="overflow: visible;osition: relative;overflow: hidden;color: #323233;text-align: left;vertical-align: middle;word-wrap: break-word;">
					<div style="display: flex;-webkit-box-align: center;-webkit-align-items: center;-ms-flex-align: center;align-items: center;">
						<div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width:85%;font-size: 14px;line-height:40px;color: #000;padding-left: 10px;">
							{{withdrawRole.fnum}}
						</div>
						<div style="padding-left:8px;margin-right:10px" @click="copys(withdrawRole.fnum)">
							<span style="color: rgb(102, 102, 102);font-size: 16px;text-align: left">Copy</span>
						</div>
					</div>
				</div>
			</div>
			<div style="width: 100%;line-height: 30px;font-size: 14px;text-align: left;padding-left: 5px;color: #999">
				{{$t("setting.band_account")}}
			</div>
			<div style="background: #fff;box-shadow: 0 0 10px 0 #e9e9e9;border-radius: 4px;height: 40px;">
				<div style="overflow: visible;osition: relative;overflow: hidden;color: #323233;text-align: left;vertical-align: middle;word-wrap: break-word;">
					<div style="display: flex;-webkit-box-align: center;-webkit-align-items: center;-ms-flex-align: center;align-items: center;">
						<div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width:85%;font-size: 14px;line-height:40px;color: #000;padding-left: 10px;">
							{{withdrawRole.cardnum}}
						</div>
						<div style="padding-left:8px;margin-right:10px" @click="copys(withdrawRole.cardnum)">
							<span style="color: rgb(102, 102, 102);font-size: 16px;text-align: left">Copy</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div style="margin-top:10px;padding: 10px 0;border-radius:10px;background-color: #fff;">
			<div style="width: 100%;line-height: 30px;font-size: 14px;text-align: left;">
				{{$t("recharge.pay_way")}}
			</div>
			<div class="pay-way-list">
				<div v-for="item in payMethods" :key="item.key" class="pay-way-item">
					<div @click="history(item.key)" :class="activePayKey === item.key ? 'aaitce' : ''" class="pay-way-btn">{{item.label || $t(item.labelKey)}}</div>
				</div>
			</div>
			<div style="margin-top: 15px;position: relative;display: -webkit-box;display: -webkit-flex;display: -ms-flexbox;display: flex;box-sizing: border-box;width: 100%;padding:10px 16px;overflow: hidden;color: #323233;font-size:14px;line-height:24px;background-color: #fff;">
				<div style="margin-right:4px;">
					<div style="margin-right:10px">
						<img style="width:20px;height:20px" src="/img/home/q.png">
					</div>
				</div>
				<div style="display: flex;-webkit-box-align: center;align-items: center;">
					<van-field type="number" style=";display: block;box-sizing: border-box;width: 80%;min-width: 0;margin: 0;padding: 0;color: #323233;line-height: inherit;text-align: left;background-color: transparent;border: 0;resize: none;" v-model="withdraw_money" :value="this.withdraw_money" :placeholder="$t('recharge.input_money')"/>
				</div>
			</div>
			<div v-if="approxMoney" class="approx-money">≈ {{approxMoney}}</div>
			<div class="recharge-limit">{{$t("recharge.amount_limit", { min: minRechargeAmount, max: maxRechargeAmount })}}</div>
			<div style="background: #d6d6d6;margin:10px auto;padding:20px 10px;text-align: center;">
				<div style="position: relative;display: inline-block">
					<div style="display: flex;flex-wrap: wrap;">
						<van-uploader v-model="fileList" multiple :max-count="1" :after-read="afterRead"><van-icon name="photograph" size="32px" /></van-uploader>
					</div>
				</div>
				<!-- <div class="upload_">
					<van-uploader v-model="fileList" multiple :max-count="1" :after-read="afterRead"/>
					{{$t('msg.scfkjt')}}
				</div> -->
				<div style="padding:10px 0;font-size:16px;color: #000;">
					{{$t("my.msg59")}}
				</div>
			</div>
			
		</div>
		<div style="padding:5px 16px;width:100%">
			<div @click="doWithdraw()" style="border-radius: 10px;;font-size: 16px;;text-align: center;;line-height: 46px;;width: 100%;height:46px;color: white;background: linear-gradient(180deg, #fc78af, #f22678);border-color: rgb(156, 206, 109);">
				{{$t("my.msg58")}}
			</div>
		</div>
	</div>
  </div>
</template>

<script>
import QRCode from "qrcode";

export default {
  data() {
    return {
      showPopover: false,
      minRechargeAmount: 10,
      maxRechargeAmount: 999999,
      withdraw_money:"",type:2,activePayKey:"usdt",class1:false,class2:true,img:"",content:"",fileList:[],qrCodeUrl:"",
      payMethods: [
        { key: "bank", type: 1, labelKey: "my.msg50" },
        { key: "eth", type: 4, label: "ETH", title: "[ETH]", addressLabel: "ETH地址", addressKey: "eth", imgKey: "ethimg" },
        { key: "usdt", type: 2, label: "USDT-TRC20", title: "[USDT] - [TRC20]", addressLabel: "USDT-TRC20地址", addressKey: "usdt", imgKey: "usdtimg" },
        { key: "usdtErc20", type: 3, label: "USDT-ERC20", title: "[USDT] - [ERC20]", addressLabel: "USDT-ERC20地址", addressKey: "eth", imgKey: "ethimg" },
        { key: "usdcTrc20", type: 6, label: "USDC-TRC20", title: "[USDC] - [TRC20]", addressLabel: "USDC-TRC20地址", addressKey: "usdt", imgKey: "usdtimg" },
        { key: "usdcErc20", type: 7, label: "USDC-ERC20", title: "[USDC] - [ERC20]", addressLabel: "USDC-ERC20地址", addressKey: "eth", imgKey: "ethimg" },
        { key: "btc", type: 5, label: "BTC", title: "[BTC]", addressLabel: "BTC地址", addressKey: "btc", imgKey: "btcimg" }
      ],
      userInfo:{},formData: {
        file: null, // 文件字段
      },
      withdrawRole:{}
    };
  },
  computed: {
    currentPayMethod() {
      return this.payMethods.find(item => item.key === this.activePayKey) || this.payMethods[1];
    },
    currentCryptoMethod() {
      return this.currentPayMethod && this.currentPayMethod.key !== "bank" ? this.currentPayMethod : null;
    },
    currentCryptoAddress() {
      return this.currentCryptoMethod ? (this.withdrawRole[this.currentCryptoMethod.addressKey] || "") : "";
    },
    approxMoney() {
      if (!this.withdraw_money || Number(this.withdraw_money) <= 0) {
        return "";
      }

      return this.getSubmitMoney();
    }
  },
  watch: {
    currentCryptoAddress() {
      this.createQrCode();
    }
  },
  methods: {
    back(){
      return window.history.back();
    },
	afterRead(event){
		console.log(event.content);
this.$http({
          method: 'post',
          data:{content:event.content},
          url: 'upimg'
        }).then(res=>{
          if(res.code === 200){
            //location. reload()
			this.img=res.data.img;
            this.$toast(res.msg);
          }else if(res.code ===401){
            this.$toast(res.msg);
          }
        })
	},getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },async copys(e) {
      try {
        // Use navigator.clipboard.writeText to copy text
        await navigator.clipboard.writeText(e);

		this.$toast("Copy successful");
      } catch (error) {
        console.error("Failed to copy text: ", error);
		this.$toast("Replication failed");
      }
    },async createQrCode() {
      if (!this.currentCryptoAddress) {
        this.qrCodeUrl = "";
        return;
      }

      this.qrCodeUrl = await QRCode.toDataURL(this.currentCryptoAddress, {
        width: 320,
        margin: 1,
        color: {
          dark: "#000000",
          light: "#ffffff"
        }
      });
    },history(e){
		const method = this.payMethods.find(item => item.key === e);
		if (!method) {
			return;
		}
		this.activePayKey = method.key;
		this.type = method.type;
		this.class1 = method.key === "bank";
		this.class2 = method.key !== "bank";
	},num(e){
		this.withdraw_money=e;
	},
    getSubmitMoney() {
      const money = Number(this.withdraw_money);
      const exchangeRates = {
        4: 2000,
        5: 65000
      };
      const rate = exchangeRates[this.type];

      if (!rate) {
        return this.withdraw_money;
      }

      return (money * rate).toFixed(2);
    },
    getUserWithdrawRole(){
      this.$http({
        method: 'get',
        url: 'user_get_recharge_role'
      }).then(res=>{
        if(res.code === 200){
          this.withdrawRole = res.data;this.bank=res.data.bank;this.usdt=res.data.usdt;this.eth=res.data.eth;this.btc=res.data.btc;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    doWithdraw(){
      const inputMoney = Number(this.withdraw_money);
      if(this.withdraw_money === "" || !Number.isFinite(inputMoney) || inputMoney <= 0){
        this.$toast(this.$t("recharge.input_money"));
        return false;
      }
      const submitMoney = Number(this.getSubmitMoney());
      if(!Number.isFinite(submitMoney) || submitMoney < this.minRechargeAmount || submitMoney > this.maxRechargeAmount){
        this.$toast(this.$t("recharge.amount_limit_error", { min: this.minRechargeAmount, max: this.maxRechargeAmount }));
        return false;
      }else {
		if(this.type==''){
			this.$toast(this.$t("my.msg57"));
			return false;
		}
        if(this.img==''){
			this.$toast(this.$t("my.msg59"));
			return false;
		}
        this.$http({
          method: 'post',
          data:{money:submitMoney,type:this.type,img:this.img},
          url: 'user_set_recharge'
        }).then(res=>{
          if(res.code === 200){
            this.$toast(res.msg);
             this.$router.push({path:'/RechargeRecord'});
          }else if(res.code ===401){
            this.$toast(res.msg);
          }
        })
      }
    },
    withdrawInfo(){
      this.showPopover = true;
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserWithdrawRole();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 35px;
  line-height: 80px;
}.aaitce{background: linear-gradient(180deg, #fc78af, #f22678) !important;color: #fff;}
.qrcode-box {
  width: 180px;
  height: 180px;
  margin: 0 auto;
  padding: 10px;
  overflow: hidden;
  border-radius: 10px;
  box-sizing: border-box;
}
.qrcode-img {
  display: block;
  width: 160px;
  height: 160px;
}
.pay-way-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 20px;
  margin: 8px 7%;
}
.pay-way-item {
  min-width: 0;
  height: 60px;
}
.pay-way-btn {
  height: 60px;
  line-height: 60px;
  width: 100%;
  overflow: hidden;
  border-radius: 10px;
  background: #d9d9d9;
  color: #000;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.approx-money {
  padding: 0 16px 10px 48px;
  color: #ff253f;
  font-size: 24px;
  font-weight: 700;
  line-height: 34px;
}
.recharge-limit {
  padding: 0 16px 10px 48px;
  color: #999;
  font-size: 18px;
  line-height: 18px;
}
.container p{
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}.upload_{
	padding: 60px 0;
	margin: 40px 0;
	width: 100%;
	text-align: center;
	background-color: #efefef;
	display: flex;
	flex-direction: column;
}
.van-uploader{
	.van-uploader__upload{
		width: 200px;
		height: 200px;
		
	}
	.van-uploader__wrapper{
		justify-content: center;
	}
}
.container .main{
  display: flex;
  flex-direction: column;
  background-color: #f2f2f5;
  height: calc(100% - 50px);
  position: relative;
}
.container .main .withdrawMoney{
  display: flex;
  flex-direction: column;
  color: #000;
  padding: 0 20px;
  white-space: nowrap;
  font-size: 35px;
  background-color: #fff;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f5;
}
.container .main .withdrawMoney .money .moneyNumber{
  font-size: 50px;
  display: flex;
  flex-direction: row;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money .all{
  color: #d10404;
}
.container .main .withdrawMoney .money .moneyNumber .van-cell {
  font-size: 50px;
  padding: 0!important;
}
.container .main .withdrawMoney .information{
  padding-bottom: 30px;
}
.container .main .withdrawMoney .information .description {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0;
}
.container .main .withdrawMoney span{
  padding: 10px 0;
}.nav-bar{background: linear-gradient(180deg, #fc78af, #f22678);}
.container .main .withdrawMoney .information .balance .number{
  color: #d10404;
}
.withdraw_btn {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(
      90deg,#e6c3a1,#7e5678);
}
</style>
